export default __webpack_public_path__ + "static/media/79793b23a766b3e69b3b217a3d79b2e0.svg";